import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import LandingFooter from "../components/LandingFooter";
import LandingHeader from "../components/LandingHeader";

function getRoutePath(pathname: string, hash: string): string {
  const routePath = hash.startsWith("#/")
    ? hash.slice(1).split("?")[0]
    : pathname;

  return routePath;
}

export default function LandingLayout() {
  const { pathname, hash } = useLocation();
  const routePath = getRoutePath(pathname, hash);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [routePath]);

  return (
    <div className="landing-root min-h-screen">
      <LandingHeader />
      <main>
        <Outlet />
      </main>
      {/* Footer shown across all landing pages (classes → detail → checkout → success) */}
      <LandingFooter />
    </div>
  );
}
